export const tabImages = {
  graphic: {
    normal: require('../icons/graphic_grey.png'),
    white: require('../icons/graphic_white.png'),
    active: require('../icons/graphic_blue.png')
  },
  design: {
    normal: require('../icons/design_grey.png'),
    white: require('../icons/design_white.png'),
    active: require('../icons/design_blue.png')
  },
  interior: {
    normal: require('../icons/interior_grey.png'),
    white: require('../icons/interior_white.png'),
    active: require('../icons/interior_blue.png')
  },
  painting: {
    normal: require('../icons/painting_grey.png'),
    white: require('../icons/painting_white.png'),
    active: require('../icons/painting_blue.png')
  }
};



// WEBPACK FOOTER //
// ./src/components/common.js